export type Flags =
  | "nftBridgeEnabled"
  | "walletExtendedActionsEnabled"
  | "shadowForkMessagesEnabled";

export type FeatureFlags = Record<Flags, boolean>;

export const featureFlags: FeatureFlags = require("./config/featureFlags.json");

export const getFeatureFlagStatus = (flag: Flags) => featureFlags[flag];
